import { useEffect, useState } from "react";
import { BsPlusCircleFill } from "react-icons/bs";
import {
  Button,
  Form,
  Row,
  Col,
  Accordion,
  Card,
  Alert,
} from "react-bootstrap";
import { withTranslation } from "react-i18next";

import Get from "../../api/Get";
import Post from "../../api/Post";
import Put from "../../api/Put";
import {
  MEDICAL_HISTORY_GET_BY_ID,
  MEDICAL_HISTORY,
  MEDICAL_HISTORY_ADD,
  MEDICAL_HISTORY_UPDATE,
  GET_APPOINTMENT_BY_ID,
} from "../../api/Routes";
import QuestionTemplate from "../QuestionTemplate";
import SimpleLoad from "../../loader/SimpleLoad";
import { checkSpeciality } from "../../utils/checkSpeciality";
import { RiPencilFill } from "react-icons/ri";
import { getElementoInside } from "../../utils/getElementoInside";
import useCompanyType from "../../hook/useCompanyType";
import { isConsultorio } from "../../utils/isConsultorio";
import {canEditDoctor} from "../../utils/isDoctor";

function ProvHistoriaClinica({
  t,
  appointmentId,
  idHM,
  auth,
  idSpeciality,
  setShowModalServer,
  setErrorServer,
  readOnly,
  validDiagnostico,
  scrollRef,
  setCita,
  age,
  reload,
  setReload, cita
}) {
  //console.log(idHM)
  const [medical, setMedical] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [idHistoriaClinica, setIdHistoriaClinica] = useState(idHM);
  const [preguntas, setPreguntas] = useState([]);
  const [respuesta, setRespuesta] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rechckedMH, setRecheckMH] = useState(true);
  const company = useCompanyType();
  const [errorTextDiag, setErrorTextDiag] = useState(null);
  const [underForthen, setUnderForthen] = useState(
    age?.years < 15 ? true : false
  );
  const [doSave, setDoSave] = useState(false);
  const [keepForm, setKeepForm] = useState(true);

  const [errorUnderF, setErrorUnderF] = useState({
    nombre: {
      error: false,
      msg: "",
    },
    tipoDocumento: {
      error: false,
      msg: "",
    },
    numeroDocumento: {
      error: false,
      msg: "",
    },
    parentezco: {
      error: false,
      msg: "",
    },
  });

  const [errorConsultorio, setErrorConsultorio] = useState({
    posologia: {
      error: false,
      msg: "",
    },
    presentacion: {
      error: false,
      msg: "",
    },
    viaDeAdministracion: {
      error: false,
      msg: "",
    },
    tiempo: {
      error: false,
      msg: "",
    },
    reaccionAdversa: {
      error: false,
      msg: "",
    },
  });

  //console.log(reload)
  useEffect(() => {
    //console.log('entroaqui')
    let id = idHistoriaClinica ? idHistoriaClinica : idHM;
    //console.log(reload)
    //console.log(id)
    if ((id && rechckedMH) || (id && reload)) {
      let mounted = true;
      setLoading(true);
      Get({
        url: `${MEDICAL_HISTORY_GET_BY_ID}/${id}`,
        access_token: auth.data.access_token,
      })
        .then((response) => {
          if (mounted) {
            setMedical(response.data.data.questionsDTOList);
            setLoading(false);
            setRecheckMH(false);
            //checamos si el paciente tiene incapacidad
            if (response.data.data.appointmentDTO?.id) {
              //console.log('entro')
              checkIncapacidad(response.data.data.appointmentDTO?.id);
            }
            setReload(false);
          } else {
            setLoading(false);
            setReload(false);
          }
        })
        .catch((error) => {
          setLoading(false);
          setShowModalServer(true);
          setReload(false);
          if (error.response) {
            setErrorServer(error.response);
          }
        });
      return () => (mounted = false);
    }
  }, [idHM, idHistoriaClinica, rechckedMH, reload]);

  useEffect(() => {
    //console.log('reload')
    //console.log(reload)
    let mounted = true;
    setLoading(true);
    Get({
      url: `${MEDICAL_HISTORY}/${appointmentId}`,
      access_token: auth.data.access_token,
    })
      .then((response) => {
        //console.log(response)
        if (mounted) {
          setPreguntas(response.data.data.response);
          setReload(false);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        setShowModalServer(true);
        if (error.response) {
          setErrorServer(error.response);
        }
        setReload(false);
      });
    return () => (mounted = false);
  }, [reload]);

  useEffect(() => {
    setUnderForthen(age?.years < 15 ? true : false);
  }, [age]);

  const handleShowForm = () => setShowForm(!showForm);

  const buildJson = (valor, idPregunta) => {
    const data = {
      id: idPregunta,
      note: "",
      qualificationDTOS: [
        {
          id: valor,
        },
      ],
    };

    let arr = [...respuesta];
    const index = arr.findIndex((item) => item.id === idPregunta);
    if (index >= 0) {
      arr[index] = data;
      setRespuesta(arr);
    } else {
      setRespuesta((respuesta) => [...respuesta, data]);
    }

    //actualizar la pregunta
    let arrP = [...preguntas];
    let indexPre = preguntas[0].questions.findIndex(
      (el) => el.id === idPregunta
    );
    if (indexPre >= 0) {
      let a = arrP[0].questions[indexPre].qualifications.map((el) => ({
        ...el,
        selected: "",
      }));
      arrP[0].questions[indexPre].qualifications = a;
      let indexQ = arrP[0].questions[indexPre].qualifications.findIndex(
        (el) => el.id === parseInt(data.qualificationDTOS[0].id)
      );
      if (indexQ >= 0) {
        arrP[0].questions[indexPre].qualifications[indexQ].selected =
          "selected";
      }
    }
  };

  const builJsonText = (valor, idPregunta) => {
    const data = {
      id: idPregunta,
      note: valor,
    };
    let arr = [...respuesta];
    const index = arr.findIndex((item) => item.id === idPregunta);
    if (index >= 0) {
      arr[index] = data;
      setRespuesta(arr);
    } else {
      setRespuesta((respuesta) => [...respuesta, data]);
    }
    //le respondemos la pregunta
    let arrP = [...preguntas];
    let indexPre = preguntas[0].questions.findIndex(
      (el) => el.id === idPregunta
    );
    if (indexPre >= 0) {
      arrP[0].questions[indexPre]["note"] = valor;
      setPreguntas(arrP);
    }
  };

  const builJsonMultiple = (checked, valor, idPregunta) => {
    let arr = [...respuesta];
    const index = arr.findIndex((item) => item.id === idPregunta);
    if (index >= 0) {
      const index2 = arr[index].qualificationDTOS.findIndex(
        (item) => item.id === valor
      );
      if (checked) {
        const d = {
          id: valor,
        };
        let arr3 = [...arr[index].qualificationDTOS, d];
        arr[index].qualificationDTOS = arr3;
        setRespuesta(arr);
      } else {
        if (index2 >= 0) {
          arr[index].qualificationDTOS.splice(index2, 1);
        }
      }
    } else {
      if (checked) {
        const data = {
          id: idPregunta,
          note: "",
          qualificationDTOS: [
            {
              id: valor,
            },
          ],
        };
        setRespuesta((respuesta) => [...respuesta, data]);
      }
    }

    //le respondemos la pregunta
    let arrP = [...preguntas];
    let indexPre = arrP[0].questions.findIndex((el) => el.id === idPregunta);
    if (indexPre >= 0) {
      let indQ = arrP[0].questions[indexPre].qualifications.findIndex(
        (el) => el.id === parseInt(valor)
      );
      let arrMutar = [...arrP[0].questions[indexPre].qualifications];
      if (checked) {
        arrMutar[indQ].selected = "selected";
        arrMutar[indQ].checked = true;
      } else {
        arrMutar[indQ].selected = null;
        arrMutar[indQ].checked = null;
      }

      arrP[0].questions[indexPre].qualifications = arrMutar;
      setPreguntas(arrP);
    }
  };

  //console.log(preguntas)
  const onClickEnviar = (kForm) => {
    if (!validDiagnostico && company === "colombia") {
      setErrorTextDiag(
        "Primero debes definir el diagnóstico antes de enviar la historia clínica"
      );
      if (scrollRef.current) {
        //scrollRef.current.scrollTo(0, 130)
      }
    } else {
      const respuestaLast = [...respuesta];
      //console.log(respuesta)
      if (
        respuestaLast.filter((r) => r.id === 114 && r.note === "N/A").length > 0
      ) {
        if (respuestaLast.filter((r) => r.id === 148).length > 0) {
          let idx = respuestaLast.findIndex((r) => r.id === 148);
          respuestaLast[idx].qualificationDTOS = [{ id: 46 }];
        } else {
          const data = {
            id: 148,
            note: "",
            qualificationDTOS: [
              {
                id: 46,
              },
            ],
          };
          respuestaLast.push(data);
        }
      }
      setErrorTextDiag(null);
      const data = {
        appointmentDTO: {
          id: appointmentId,
        },
        questionOfGroupDTOS: respuestaLast,
      };
      let checkValid = true;
      if (underForthen) {
        //cuando esnueva siempre tienen que ir los 4 campos para completar
        const v141 =
          data.questionOfGroupDTOS.filter((it) => it.id === 141).length > 0;
        const v140 =
          data.questionOfGroupDTOS.filter((it) => it.id === 140).length > 0;
        const v139 =
          data.questionOfGroupDTOS.filter((it) => it.id === 139).length > 0;
        const v138 =
          data.questionOfGroupDTOS.filter((it) => it.id === 138).length > 0;
        if (v141 && v140 && v139 && v138) {
          checkValid = checkValidacionUnderF(data);
        } else {
          checkValid = false;
          setErrorUnderF({
            nombre: {
              error: !v138,
              msg: "Campo nombre del responsable es requerido",
            },
            tipoDocumento: {
              error: !v139,
              msg: "Campo tipo de identificación es requerido",
            },
            numeroDocumento: {
              error: !v140,
              msg: "Campo No. de identificación es requerido",
            },
            parentezco: {
              error: !v141,
              msg: "Campo parentesco es requerido",
            },
          });
        }

        //validamos documento con tipo doc
        if (checkValid) {
          checkValid = checkValidacionDocument();
        }
      }
      if (isConsultorio(auth.data.role)) {
        const v142 =
          data.questionOfGroupDTOS.filter((it) => it.id === 142).length > 0;
        if (v142) {
          const v143 =
            data.questionOfGroupDTOS.filter((it) => it.id === 143).length > 0;
          const v144 =
            data.questionOfGroupDTOS.filter((it) => it.id === 144).length > 0;
          const v145 =
            data.questionOfGroupDTOS.filter((it) => it.id === 145).length > 0;
          const v146 =
            data.questionOfGroupDTOS.filter((it) => it.id === 146).length > 0;
          const v147 =
            data.questionOfGroupDTOS.filter((it) => it.id === 147).length > 0;

          if (v143 && v144 && v145 && v146 && v147) {
            setErrorConsultorio({
              posologia: {
                error: false,
                msg: "",
              },
              presentacion: {
                error: false,
                msg: "",
              },
              viaDeAdministracion: {
                error: false,
                msg: "",
              },
              tiempo: {
                error: false,
                msg: "",
              },
              reaccionAdversa: {
                error: false,
                msg: "",
              },
            });
          } else {
            checkValid = false;
            setErrorConsultorio({
              posologia: {
                error: !v143,
                msg: "Campo posología es requerido",
              },
              presentacion: {
                error: !v144,
                msg: "Campo presentación es requerido",
              },
              viaDeAdministracion: {
                error: !v145,
                msg: "Campo vía de administración es requerido",
              },
              tiempo: {
                error: !v146,
                msg: "Campo tiempo es requerido",
              },
              reaccionAdversa: {
                error: !v147,
                msg: "Campo reacción adversa es requerido",
              },
            });
          }
        }
      }

      if (checkValid) {
        setErrorUnderF({
          nombre: {
            error: false,
            msg: "",
          },
          tipoDocumento: {
            error: false,
            msg: "",
          },
          numeroDocumento: {
            error: false,
            msg: "",
          },
          parentezco: {
            error: false,
            msg: "",
          },
        });
        setLoading(true);
        Post({
          url: MEDICAL_HISTORY_ADD,
          data: data,
          header: true,
          access_token: auth.data.access_token,
        })
          .then((response) => {
            setRecheckMH(true);
            setIdHistoriaClinica(response.data.data.id);
            if (!kForm) {
              setShowForm(!showForm);
            }
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
            setShowModalServer(true);
            if (error.response) {
              setErrorServer(error.response);
            }
          });
      } else {
        //scrollRef.current.scrollTo(0, 130)
      }
    }
  };

  const handleEditEnviar = (kForm) => {
    let arr = [...respuesta];
    let arrCasillas = preguntas[0].questions.filter(
      (el) => el.questionType.tipoPregunta.id === 2
    );
    if (arrCasillas.length > 0) {
      let arrChecked = getElementoInside(arrCasillas, arr);
      arrChecked.forEach((element) => {
        let index = arr.findIndex((e) => e.id === element.id);
        if (index >= 0) {
          arr[index].qualificationDTOS = element.checked;
        } else {
          const dAux = {
            id: element.id,
            note: "",
            qualificationDTOS: element.checked,
          };
          arr.push(dAux);
        }
      });
    }
    const data = {
      appointmentDTO: {
        id: appointmentId,
      },
      questionOfGroupDTOS: arr,
    };
    let checkValid = true;

    //console.log(underForthen)
    if (underForthen) {
      const v141 =
        data.questionOfGroupDTOS.filter((it) => it.id === 141).length > 0 ||
        medical[0].questionOfGroupDTOS
          .filter((it) => it.id === 141)[0]
          .qualificationDTOS.filter((q) => q.selected === "selected").length >
          0;
      const v140 =
        data.questionOfGroupDTOS.filter((it) => it.id === 140).length > 0 ||
        medical[0].questionOfGroupDTOS.filter((it) => it.id === 140)[0].note
          .length > 0;
      const v139 =
        data.questionOfGroupDTOS.filter((it) => it.id === 139).length > 0 ||
        medical[0].questionOfGroupDTOS
          .filter((it) => it.id === 139)[0]
          .qualificationDTOS.filter((q) => q.selected === "selected").length >
          0;
      const v138 =
        data.questionOfGroupDTOS.filter((it) => it.id === 138).length > 0 ||
        medical[0].questionOfGroupDTOS.filter((it) => it.id === 138)[0].note
          .length > 0;
      if (v141 && v140 && v139 && v138) {
        checkValid = checkValidacionUnderF(data);
      } else {
        checkValid = false;
        setErrorUnderF({
          nombre: {
            error: !v138,
            msg: "Campo nombre del responsable es requerido",
          },
          tipoDocumento: {
            error: !v139,
            msg: "Campo tipo de identificación es requerido",
          },
          numeroDocumento: {
            error: !v140,
            msg: "Campo No. de identificación es requerido",
          },
          parentezco: {
            error: !v141,
            msg: "Campo parentesco es requerido",
          },
        });
      }

      //validamos documento con tipo doc
      if (checkValid) {
        checkValid = checkValidacionDocument();
      }
    }

    if (isConsultorio(auth.data.role)) {
      const Norequerido =
        data.questionOfGroupDTOS.filter((it) => it.id === 142).length > 0 &&
        data.questionOfGroupDTOS.filter((it) => it.id === 142)[0].note
          .length === 0;

      if (!Norequerido) {
        const Rv143 =
          data.questionOfGroupDTOS.filter((it) => it.id === 143).length > 0 &&
          data.questionOfGroupDTOS.filter((it) => it.id === 143)[0].note
            .length === 0;

        if (Rv143) {
          checkValid = false;
          setErrorConsultorio((prev) => ({
            ...prev,
            posologia: {
              error: true,
              msg: "Campo posología es requerido",
            },
          }));
        } else {
          setErrorConsultorio((prev) => ({
            ...prev,
            posologia: {
              error: false,
              msg: "",
            },
          }));
        }

        const Rv144 =
          data.questionOfGroupDTOS.filter((it) => it.id === 144).length > 0 &&
          data.questionOfGroupDTOS.filter((it) => it.id === 144)[0].note
            .length === 0;

        if (Rv144) {
          checkValid = false;
          setErrorConsultorio((prev) => ({
            ...prev,
            presentacion: {
              error: true,
              msg: "Campo presentación es requerido",
            },
          }));
        } else {
          setErrorConsultorio((prev) => ({
            ...prev,
            presentacion: {
              error: false,
              msg: "",
            },
          }));
        }

        const Rv145 =
          data.questionOfGroupDTOS.filter((it) => it.id === 145).length > 0 &&
          data.questionOfGroupDTOS.filter((it) => it.id === 145)[0].note
            .length === 0;

        if (Rv145) {
          checkValid = false;
          setErrorConsultorio((prev) => ({
            ...prev,
            viaDeAdministracion: {
              error: true,
              msg: "Campo vía de administración es requerido",
            },
          }));
        } else {
          setErrorConsultorio((prev) => ({
            ...prev,
            viaDeAdministracion: {
              error: false,
              msg: "",
            },
          }));
        }

        const Rv146 =
          data.questionOfGroupDTOS.filter((it) => it.id === 146).length > 0 &&
          data.questionOfGroupDTOS.filter((it) => it.id === 146)[0].note
            .length === 0;

        if (Rv146) {
          checkValid = false;
          setErrorConsultorio((prev) => ({
            ...prev,
            tiempo: {
              error: true,
              msg: "Campo tiempo es requerido",
            },
          }));
        } else {
          setErrorConsultorio((prev) => ({
            ...prev,
            tiempo: {
              error: false,
              msg: "",
            },
          }));
        }

        const Rv147 =
          data.questionOfGroupDTOS.filter((it) => it.id === 147).length > 0 &&
          data.questionOfGroupDTOS.filter((it) => it.id === 147)[0].note
            .length === 0;

        if (Rv147) {
          checkValid = false;
          setErrorConsultorio((prev) => ({
            ...prev,
            reaccionAdversa: {
              error: true,
              msg: "Campo reacción adversa es requerido",
            },
          }));
        } else {
          setErrorConsultorio((prev) => ({
            ...prev,
            reaccionAdversa: {
              error: false,
              msg: "",
            },
          }));
        }
      } else {
        setErrorConsultorio({
          posologia: {
            error: false,
            msg: "",
          },
          presentacion: {
            error: false,
            msg: "",
          },
          viaDeAdministracion: {
            error: false,
            msg: "",
          },
          tiempo: {
            error: false,
            msg: "",
          },
          reaccionAdversa: {
            error: false,
            msg: "",
          },
        });
      }
    }

    if (checkValid) {
      if (arr.filter((a) => a.id === 114 && a.note === "N/A").length > 0) {
        const arrLast = [...arr];
        if (arrLast.filter((r) => r.id === 148).length > 0) {
          let idx = arrLast.findIndex((r) => r.id === 148);
          arrLast[idx].qualificationDTOS = [{ id: 46 }];
          data.questionOfGroupDTOS = arrLast;
        } else {
          const d = {
            id: 148,
            note: "",
            qualificationDTOS: [
              {
                id: 46,
              },
            ],
          };
          arrLast.push(d);
          data.questionOfGroupDTOS = arrLast;
        }
      }
    }

    if (checkValid) {
      setErrorUnderF({
        nombre: {
          error: false,
          msg: "",
        },
        tipoDocumento: {
          error: false,
          msg: "",
        },
        numeroDocumento: {
          error: false,
          msg: "",
        },
        parentezco: {
          error: false,
          msg: "",
        },
      });
      setLoading(true);
      Put({
        url: MEDICAL_HISTORY_UPDATE,
        data: data,
        header: true,
        access_token: auth.data.access_token,
      })
        .then((response) => {
          setIdHistoriaClinica(response?.data?.data?.id);
          if (!kForm) {
            setShowForm(!showForm);
          }
          setRecheckMH(true);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          setShowModalServer(true);
          if (error.response) {
            setErrorServer(error.response);
          }
        });
    } else {
      //scrollRef.current.scrollTo(0, 130)
    }
  };

  const handleShowEditForm = () => {
    setErrorTextDiag("");
    let arr = [...preguntas];
    medical[0].questionOfGroupDTOS.forEach((element) => {
      let index = arr[0].questions.findIndex((e) => e.id === element.id);
      if (index >= 0) {
        arr[0].questions[index].qualifications = element.qualificationDTOS;
        arr[0].questions[index].note = element.note;
      }
    });
    setPreguntas(arr);
    setShowForm(true);
  };

  const checkIncapacidad = (id) => {
    Get({
      url: `${GET_APPOINTMENT_BY_ID}/${id}`,
      access_token: auth.data.access_token,
    })
      .then((response) => {
        let current_cita = response.data.data;
        setCita((prev) => ({
          ...prev,
          disability: current_cita.disability,
        }));
      })
      .catch((error) => {
        console.log(error);
      });
  };
  //console.log(isValid)
  const checkValidacionUnderF = (data) => {
    let valid = true;
    data.questionOfGroupDTOS.forEach((element) => {
      if (element.id === 141) {
        if (element.qualificationDTOS.filter((it) => it.id === "").length > 0) {
          setErrorUnderF((prev) => ({
            ...prev,
            parentezco: {
              error: true,
              msg: "Campo parentesco es requerido",
            },
          }));
          valid = false;
        } else {
          setErrorUnderF((prev) => ({
            ...prev,
            parentezco: {
              error: false,
              msg: "",
            },
          }));
        }
      }
      if (element.id === 140) {
        if (element.note === "") {
          setErrorUnderF((prev) => ({
            ...prev,
            numeroDocumento: {
              error: true,
              msg: "Campo No. de identificación es requerido",
            },
          }));
          valid = false;
        } else {
          setErrorUnderF((prev) => ({
            ...prev,
            numeroDocumento: {
              error: false,
              msg: "",
            },
          }));
        }
      }
      if (element.id === 139) {
        if (element.qualificationDTOS.filter((it) => it.id === "").length > 0) {
          setErrorUnderF((prev) => ({
            ...prev,
            tipoDocumento: {
              error: true,
              msg: "Campo tipo de identificación es requerido",
            },
          }));
          valid = false;
        } else {
          setErrorUnderF((prev) => ({
            ...prev,
            tipoDocumento: {
              error: false,
              msg: "",
            },
          }));
        }
      }
      if (element.id === 138) {
        if (element.note === "") {
          setErrorUnderF((prev) => ({
            ...prev,
            nombre: {
              error: true,
              msg: "Campo nombre del responsable es requerido",
            },
          }));
          valid = false;
        } else {
          setErrorUnderF((prev) => ({
            ...prev,
            nombre: {
              error: false,
              msg: "",
            },
          }));
        }
      }
    });
    return valid;
  };
  //console.log(preguntas)
  const checkValidacionDocument = () => {
    let valid = true;
    const indexTipoD = preguntas[0].questions.findIndex((it) => it.id === 139);
    const indexD = preguntas[0].questions.findIndex((it) => it.id === 140);

    const tipoD = preguntas[0].questions[indexTipoD].qualifications.filter(
      (it) => it.selected === "selected"
    )[0];
    //console.log(tipoD)
    const code = tipoD.label.split(" ")[0];
    //console.log(code)

    const document = preguntas[0].questions[indexD].note;

    if (code === "AS" || code === "MS") {
      return true;
    }
    if (document.length < 5 || document.length > getLengthDN(code)) {
      valid = false;
      setErrorUnderF((prev) => ({
        ...prev,
        numeroDocumento: {
          error: true,
          msg: `Campo No. de identificación debe tener una longitud entre 5 y ${getLengthDN(
            code
          )} caracteres`,
        },
      }));
    }

    return valid;
  };

  const getLengthDN = (code) => {
    switch (code.toUpperCase()) {
      case "CE":
        return 12;
      case "CD":
      case "PA":
      case "SC":
        return 16;
      case "PE":
        return 15;
      case "RC":
      case "TI":
        return 11;
      case "CN":
        return 9;
      case "MS":
        return 12;
      default:
        return 10;
    }
  };

  useEffect(() => {
    if (doSave) {
      const timeoutID = setTimeout(() => {
        if (idHM || idHistoriaClinica) {
          handleEditEnviar(true);
        } else {
          onClickEnviar(true);
        }
        setDoSave(false);
      }, 1000);

      return () => {
        clearTimeout(timeoutID);
      };
    }
  }, [doSave]);

  return (
    <div className="p-3 pt-4 position-relative">
      {loading && <SimpleLoad />}
      {!showForm && (idHM || idHistoriaClinica) && !readOnly &&
          canEditDoctor(cita, auth) && (
              <Button
                  variant="outline-info"
                  className="position-absolute right-absolute"
                  size="sm"
                  onClick={handleShowEditForm}
              >
                <RiPencilFill />
              </Button>
          )}

      {!showForm ? (
        <>
          {!idHistoriaClinica && !idHM && !readOnly && canEditDoctor(cita, auth) && (
            <div className="cita-btn-add-container" onClick={handleShowForm}>
              <BsPlusCircleFill className="cita-btn-add-item" /> &nbsp;
              <Button variant="outline-primary" type="button" size="sm">
                {checkSpeciality(idSpeciality)
                  ? "Crear resumen de consulta"
                  : t("crear_ficha_medica")}
              </Button>{" "}
            </div>
          )}

          {(idHistoriaClinica || idHM) &&
            medical.map(
              (item, i) =>
                item.questionOfGroupDTOS.length > 0 && (
                  <div key={i}>
                    <label className="font-weight-bold font-size-08rem mb-1 text-secondary">
                      {item.questionGroup}
                    </label>
                    <ul className="list-unstyled font-size-08rem pl-3 color-989898">
                      {item.questionOfGroupDTOS.map((subIt, subI) => (
                        <li key={subI}>
                          <span className="font-weight-bold-600">
                            {subIt.label}:{" "}
                          </span>
                          {subIt.qualificationDTOS.length > 0
                            ? subIt.qualificationDTOS.filter(
                                (q) => q?.selected === "selected"
                              )[0]?.label
                            : subIt.note}
                        </li>
                      ))}
                    </ul>
                  </div>
                )
            )}
        </>
      ) : (
        <>
          <Form className="mt-3">
            {errorTextDiag && (
              <Alert variant="danger" className="p-1">
                {errorTextDiag}
              </Alert>
            )}
            {errorUnderF.nombre.error && (
              <Alert variant="danger" className="p-1">
                {errorUnderF.nombre.msg}
              </Alert>
            )}
            {errorUnderF.tipoDocumento.error && (
              <Alert variant="danger" className="p-1">
                {errorUnderF.tipoDocumento.msg}
              </Alert>
            )}
            {errorUnderF.numeroDocumento.error && (
              <Alert variant="danger" className="p-1">
                {errorUnderF.numeroDocumento.msg}
              </Alert>
            )}
            {errorUnderF.parentezco.error && (
              <Alert variant="danger" className="p-1">
                {errorUnderF.parentezco.msg}
              </Alert>
            )}

            {errorConsultorio.posologia.error && (
              <Alert variant="danger" className="p-1">
                {errorConsultorio.posologia.msg}
              </Alert>
            )}
            {errorConsultorio.presentacion.error && (
              <Alert variant="danger" className="p-1">
                {errorConsultorio.presentacion.msg}
              </Alert>
            )}
            {errorConsultorio.reaccionAdversa.error && (
              <Alert variant="danger" className="p-1">
                {errorConsultorio.reaccionAdversa.msg}
              </Alert>
            )}
            {errorConsultorio.tiempo.error && (
              <Alert variant="danger" className="p-1">
                {errorConsultorio.tiempo.msg}
              </Alert>
            )}
            {errorConsultorio.viaDeAdministracion.error && (
              <Alert variant="danger" className="p-1">
                {errorConsultorio.viaDeAdministracion.msg}
              </Alert>
            )}

            {preguntas.map((pregunta, p) => {
              return pregunta?.questions.length > 0 ? (
                <Row
                  className="historia-clinica-questions-container"
                  key={`pregunta-${p}`}
                >
                  <Col>
                    <Accordion defaultActiveKey={p === 0 ? "0" : ""}>
                      <Card>
                        <Card.Header>
                          <Accordion.Toggle
                            as={Button}
                            variant="link"
                            eventKey="0"
                          >
                            {pregunta?.questionGroup}
                          </Accordion.Toggle>
                        </Card.Header>
                        <Accordion.Collapse eventKey="0">
                          <Card.Body>
                            {pregunta?.questions.map((question, q) => {
                              return (
                                <Form.Group key={q}>
                                  <Form.Label>
                                    {question.questionType?.label}
                                  </Form.Label>
                                  <QuestionTemplate
                                    questionId={question.id}
                                    questionType={question.questionType}
                                    qualifications={question.qualifications}
                                    buildJson={buildJson}
                                    builJsonText={builJsonText}
                                    builJsonMultiple={builJsonMultiple}
                                    isUpdate={false}
                                    note={question.note}
                                    setDoSave={setDoSave}
                                  />
                                </Form.Group>
                              );
                            })}
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                    </Accordion>
                  </Col>
                </Row>
              ) : (
                <div key={`pregunta-${p}`}></div>
              );
            })}

            <Row className="grupoBotones">
              <Col>
                <Button
                  variant="danger"
                  className="cancelar-buttom"
                  type="button"
                  onClick={handleShowForm}
                >
                  {" "}
                  {t("cancelar")}{" "}
                </Button>{" "}
              </Col>
              <Col className="text-right">
                {idHM || idHistoriaClinica ? (
                  <Button
                    variant="outline-success"
                    className="ok-buttom"
                    type="button"
                    onClick={() => {
                      handleEditEnviar(false);
                    }}
                  >
                    {t("aceptar")}
                  </Button>
                ) : (
                  <Button
                    variant="outline-success"
                    className="ok-buttom"
                    type="button"
                    onClick={() => {
                      onClickEnviar(false);
                    }}
                  >
                    {t("aceptar")}
                  </Button>
                )}
              </Col>
            </Row>
          </Form>
        </>
      )}
    </div>
  );
}

export default withTranslation()(ProvHistoriaClinica);
